import type { CSSProperties, ComputedRef, InjectionKey, Ref } from 'vue'
import { UseNamespaceReturn } from '@sgui-plus/hooks'

export type ModalContext = {
  ns: UseNamespaceReturn
  modalRef: Ref<HTMLElement | undefined>
  headerRef: Ref<HTMLElement | undefined>
  footerRef: Ref<HTMLElement | undefined>
  bodyId: Ref<string>
  rendered: Ref<boolean>
  style: ComputedRef<CSSProperties>
  isMax: Ref<boolean>
  isFull: Ref<boolean>
  isMini: Ref<boolean>
  propsHeight?: string | number
}

export const ModalContextKey: InjectionKey<ModalContext> = Symbol('ModalContextKey')
